import { Component } from '@angular/core';
import { NavController, NavParams, ModalController, FabContainer, AlertController } from 'ionic-angular';
import moment from 'moment'
import { HttpProvider } from '../../providers/http/http';
import { CargandoPage } from '../cargando/cargando';
import { CrearProyeccionPage } from '../crear-proyeccion/crear-proyeccion';
moment.locale('es')

/**
 * Generated class for the ProyeccionesPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-proyecciones',
  templateUrl: 'proyecciones.html',
})
export class ProyeccionesPage {
  fecha = new Date().toISOString()
  vendedores = []
  maximo = new Date().toISOString()
  modl: any
  progress: any = 0
  skip: any = 0 
  police = false
  monthShortNames=["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"]
  constructor(
    public navCtrl: NavController,
    public modal : ModalController,
    public alertCtrl: AlertController,
    public http: HttpProvider,
    public navParams: NavParams
    ) {
  }

  doInfinite(infiniteScroll){
    if(window.localStorage.getItem('network') === '1') {
      if (!this.police) {
        this.http.get("vendedor/proyecciones?fecha=" + this.fecha + "&skip=" + this.skip+ "&vendedores="+window.localStorage.getItem('vendedores')).subscribe((res:any) =>{
          if (res && res.length > 0) {
            this.vendedores = this.vendedores.concat(res)
            this.skip+=10
          } else {
            this.police = true
          }
          this.modl.dismiss()
          infiniteScroll.complete()
        }, err=>{
          console.log(err)
          infiniteScroll.complete()
          this.modl.dismiss()
        })
      } else {
        infiniteScroll.complete()
      }
    } else {
      infiniteScroll.complete()
    }
  }

  ionViewWillEnter() {
    let act = this.navParams.get('act')|| null;
    if (act && act == "Si") this.initialize()
    this.navCtrl.getActive().data.act = null;
}

  ionViewDidLoad() {
    this.initialize()
  }

  validarPor(item) {
    return item > 100 ? 100 : item
  }

  
  calcularFaltanteMarca(item) {
    if (parseFloat(item.cantidadM) > parseFloat(item.cantidad)) {
      return 0
    } else {
      let cant = parseFloat(item.cantidadM) - parseFloat(item.cantidad)
      if (cant < 0) cant = cant * -1
      return (cant).toFixed(0)
    }
  }

  calcularFaltante(item) {
    if (parseFloat(item.totalPedido) > parseFloat(item.proyeccion)) {
      return 0
    } else {
      return (parseFloat(item.proyeccion) - parseFloat(item.totalPedido)).toFixed(2)
    }
  }

  calcularFaltanteArt(item) {
    if (parseFloat(item.renglones) > parseFloat(item.proyeccionP)) {
      return 0
    } else {
      return (parseFloat(item.proyeccionP) - parseFloat(item.renglones)).toFixed(0)
    }
  }

  calcularFaltanteCli(item) {
    if (parseFloat(item.clientes) > parseFloat(item.proyeccionC)) {
      return 0
    } else {
      return (parseFloat(item.proyeccionC) - parseFloat(item.clientes)).toFixed(0)
    }
  }

  initialize() {
    this.skip = 0;
    this.modl = this.modal.create(CargandoPage)
    if(window.localStorage.getItem('network') === '1') {
      this.modl.present()
      this.http.get("vendedor/proyecciones?skip=" + this.skip+ "&vendedores="+window.localStorage.getItem('vendedores')).subscribe((res:any) =>{
        this.vendedores = res
        this.skip+=10
        this.modl.dismiss()
      }, err=>{
        console.log(err)
        this.modl.dismiss()
      })
    } else {
      this.alertCtrl.create({
        title: 'Atención',
        subTitle:'No se encuentra conexión con ninguna red.',
        buttons:[
          {
            text:'Aceptar',
            cssClass:'btnAceptar',
            handler:()=>{
            }
          }
        ]
      }).present()
    }
  }

  crear() {
    this.navCtrl.push(CrearProyeccionPage)
  }
  
  eliminarProyeccion(item, indice, fab: FabContainer) {
    fab.close()
    if(window.localStorage.getItem('network') === '1') {
      this.modl.present()
      this.http.delete("proyeccion/" + item).subscribe(async (res:any) =>{
        this.vendedores.splice(indice, 1)
        this.modl.dismiss()
      }, err=>{
        console.log(err)
        this.modl.dismiss()
      })
    } else {
      this.alertCtrl.create({
        title: 'Atención',
        subTitle:'No se encuentra conexión con ninguna red.',
        buttons:[
          {
            text:'Aceptar',
            cssClass:'btnAceptar',
            handler:()=>{
            }
          }
        ]
      }).present()
    }
  }
  
  editarProyeccion(item, fab: FabContainer) {
    fab.close()
    let info = {
      _id: item.idProyeccion,
      co_ven: item.co_ven,
      ven_des: item.ven_des,
      monto: item.proyeccion
    }
    this.navCtrl.push(CrearProyeccionPage, {value: info})
  }

  searchDate() {
    this.modl = this.modal.create(CargandoPage)
    if(window.localStorage.getItem('network') === '1') {
      this.modl.present()
      this.skip = 0
      this.http.get("vendedor/proyecciones?fecha=" + this.fecha + "&skip=" + this.skip+ "&vendedores="+window.localStorage.getItem('vendedores')).subscribe((res:any) =>{
        this.vendedores = res
        this.skip+=10
        this.modl.dismiss()
      }, err=>{
        console.log(err)
        this.modl.dismiss()
      })
    } else {
      this.alertCtrl.create({
        title: 'Atención',
        subTitle:'No se encuentra conexión con ninguna red.',
        buttons:[
          {
            text:'Aceptar',
            cssClass:'btnAceptar',
            handler:()=>{
            }
          }
        ]
      }).present()
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/proyecciones/proyecciones.ts